export const TOP = '/';

export const FAQ = '/faq';

export const TERMS = '/terms';

export const TOKUSHOHO = '/tokushoho';

export const PRIVACY = '/privacy';

export const LOGIN = '/account/login';

export const PRE_LOGIN = '/account/pre_login';

export const PRE_REGIST = '/account/pre_regist';

export const MY_PAGE = '/account/mypage';

export const MY_HISTORY = '/account/history';

export const ENTRY = '/account/entry';

export const ACCOUNT_CONFIRM = '/account/confirm';

export const ACCOUNT_COMPLETE = '/account/complete';

export const UPDATE_INFO = '/account/update_info';

export const UPDATE_INFO_COMPLETE = '/account/update_info/complete';

export const ID_FORGET = '/account/id_forget';

export const ID_FORGET_COMPLETE = '/account/id_forget/complete';

export const PASS_FORGET = '/account/pass_forget';

export const PASS_FORGET_SEND = '/account/pass_forget/send';

export const PASS_FORGET_SETTING = '/account/pass_forget/setting';

export const PASS_FORGET_COMPLETE = '/account/pass_forget/complete';

export const UPDATE_MAIL = '/account/update_mail';

export const UPDATE_MAIL_SEND = '/account/update_mail/send';

export const UPDATE_MAIL_CONFIRM = '/account/update_mail/confirm';

export const UPDATE_MAIL_COMPLETE = '/account/update_mail/complete';

export const UPDATE_PASS = '/account/update_pass';

export const UPDATE_PASS_COMPLETE = '/account/update_pass/complete';

export const DELETE = '/account/delete';

export const DELETE_CONFIRM = '/account/delete/confirm';

export const DELETE_COMPLETE = '/account/delete/complete';

export const KENTEI_DETAIL = '/kentei/detail';

export const EXAM_READY = '/exam/ready';

export const EXAM = '/exam';

export const EXAM_FINISH = '/exam/finish';

export const EXAM_RESULT = '/exam/result';

export const GUEST_EXAM = '/guest_exam';

export const GUEST_EXAM_FINISH = '/guest_exam/finish';

export const GUEST_EXAM_RESULT = '/guest_exam/result';

export const TEST_EXAM_READY = '/test_exam/ready';

export const TEST_EXAM = '/test_exam';

export const TEST_EXAM_FINISH = '/test_exam/finish';

export const GOODS_LIST = '/goods/list';

export const GOODS_DETAIL = '/goods/detail';

export const GOODS_CONFIRM = '/goods/confirm';

export const GOODS_RESULT = '/goods/result';

export const CONTENTS = '/contents';

export const PURCHASE_CART_CONFIRM = '/purchase/cart_confirm';

export const PURCHASE_RESULT = '/purchase/result';

export const PURCHASE_CANNOT_PURCHASE = '/purchase/cannot_purchase';
